import css from "./LineTabs.module.scss";
import React, {forwardRef} from "react";

const LineTabItem = forwardRef(({
  label,
  icon,
  count,
  disabled,
  active,
  onClick},
  ref
) => (
  <button
    ref={ref}
    className={`${css.tab} ${active ? css.active : ''} ${disabled ? css.disabled : ''}`}
    disabled={disabled}
    onClick={() => !disabled && onClick && onClick()}
    type="button"
  >
    {icon && <span className={css.icon}>{icon}</span>}
    {label && <span>{label}</span>}
    {typeof count === 'number' && (
      <span className={`${css.badge} ${count > 0 ? css.hasCount : ''}`}>{count}</span>
    )}
  </button>
));

LineTabItem.displayName = 'LineTabItem';

export default LineTabItem;
